import { ProductEnumDTO } from "features/shared/enums/dynamic/ProductEnumDTO";
import RadioBox from "features/shared/forms/components/radioBox/RadioBox";
import { BindCheckFieldFunction } from "features/shared/forms/hooks/useForm";
import React from "react";
import styles from "./productBox.module.scss";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useInjection } from "infrastructure/ioc/ioc.react";
import IContentDialogService from "features/shared/components/contentDialog/IContentDialogService";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import ProductInfoSubDialog from "./ProductInfoSubDialog";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";

type Props = {
  product: ProductEnumDTO;
  bindCheckField: BindCheckFieldFunction;
};

const ProductBox = ({ product, bindCheckField }: Props) => {
  // DI
  const dialogService = useInjection<IContentDialogService>(
    IocTypes.ContentDialogService
  );

  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "productBox");

  // helpers
  const getIcon = (): IconProp => {
    switch (product.commodity) {
      case "Electricity":
        return "bolt";
      case "Gas":
        return "fire";
      default:
        return "file-alt";
    }
  };

  // handlers
  const openInfoDialogHandler = () => {
    dialogService.openDialog(
      product.name!,
      () => (
        <ProductInfoSubDialog product={product} />
      )
    );
  };

  // render
  return (
    <div className={styles.productWrapper}>
      <RadioBox
        label={product.name!}
        text={product.descriptionShort ?? tLabels("descriptionUndefined")}
        icon={{ icon: getIcon(), size: "3x" }}
        {...bindCheckField("productCode", product.code)}
        className={styles.productBox}
        classNameText={styles.productBoxText}
        classNameTitle={styles.productBoxTitle}
        classNameIcon={styles.productBoxIcon}
      />
      <span
        role="button"
        className={styles.productBoxInfoBtn}
        onClick={openInfoDialogHandler}
      >
        {tLabels("showMore")}
      </span>
    </div>
  );
};

export default ProductBox;
